import { Address } from 'nftx.js';
import AssetImage from './AssetImage';
import { HTMLAttributes } from 'react';
import useAsset from '@/application/read/assets/useAsset';

interface Props extends HTMLAttributes<any> {
  assetAddress: Address;
  tokenId: `${number}`;
  className?: string;
}

const AssetImageContainer = ({ assetAddress, tokenId, ...props }: Props) => {
  const { data: meta, isLoading } = useAsset({ assetAddress, tokenId });

  return (
    <AssetImage
      {...props}
      imageUrl={meta?.imageUrl ?? ''}
      name={meta?.name ?? ''}
      tokenId={tokenId}
      isLoading={isLoading}
    />
  );
};

export default AssetImageContainer;
